import { GamoraConstructorType } from '../generic.js';

/**
 * GamoraFoundationNodeConstructorType
 * @internal
 */
export type GamoraFoundationErrorConstructorType =
  GamoraConstructorType<GamoraFoundationError>;

/**
 * GamoraFoundationError
 *
 * Abstract class for error types
 * @public
 */
export abstract class GamoraFoundationError extends Error {
  constructor(message?: string) {
    super(message);
  }
}
